/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, IconButton, Collapse, CircularProgress, TextField } from '@material-ui/core'
import MuiTooltip from '@material-ui/core/Tooltip'

import { FilterList, Refresh } from '@material-ui/icons'
import { Autocomplete } from '@material-ui/lab';

import {ResponsiveContainer, ComposedChart, Line, Area, Text, Bar, Tooltip, XAxis, YAxis, CartesianGrid, Legend} from 'recharts'

import Action from '../../../../fluid/Actions/ActionFactory'
import generateData from '../../DataGenerator/dataGenerator'
import aggregateData from '../../DataGenerator/dataAggregator'
import colors from '../../DataGenerator/Color'
import signals from '../../DataGenerator/Signals';

import ErrorMessage from '../../../Common/ErrorMessage';


class CustomizedAxisTick extends Component {
    render () {
        const {x, y, payload} = this.props;
        return <Text x={x} y={y} height={'auto'} textAnchor="middle" verticalAnchor="start" wordWrap='break-word'>{payload.value}</Text>
    }
}


const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})


const styles = theme => ({

})


class ChartComponent extends Component {
    state = {
        loading : false,
        open_setting : false,
        content_height : null,
        data : null,
        data_error : null,
        entity_list : [],
        signal_params : {},
        filter_error : false,
        zero_data : []
    }

    title_bar = React.createRef()

    componentWillMount () {
        let signal_params = {}
        let signal_config = signals.find(signal => signal.type === this.props.signal_type)
        console.log("Chart Signal Config: ", signal_config)
        signal_config.parameters.map(param => {
            signal_params[param.name] = param.default_value
        })

        this.setState({
            ...this.state,
            signal_params : signal_params
        }, () => console.log("Chart Initial State: ", this.state))
    }

    componentDidMount = () => {
        let content_height = this.props.height - this.title_bar.current.clientHeight
        this.setState({...this.state, content_height : content_height}, () => this.getData())
    }

    componentDidUpdate (prevProps) {
        if (JSON.stringify(prevProps.filter) !== JSON.stringify(this.props.filter)) {
            this.getData()
        }
    }

    toggleSettings = () => {
        this.setState({
            ...this.state,
            open_setting : !this.state.open_setting
        }, () => {
            if (!this.state.open_setting) {
                this.getData()
            }
        })
    }

    getValueObject = (name, value) => {
        let signal_config = signals.find(signal => signal.type === this.props.signal_type)
        let params = signal_config.parameters
        let cur_param = params.find(param => param.name === name)
        let valueObject = cur_param.values.find(val => val.value === value)

        return valueObject
    }

    getData = () => {
        if (this.props.filter !== null) {
            let entity_list = []
            if (this.state.entity_list.length > 0) {
                entity_list = this.state.entity_list.map(entity => {
                    return entity[this.props.chart_config.entity_id]
                })
            }

            this.setState({...this.state, loading : true}, () => {
                Action('http_request', {
                    url : this.props.drl_url + "/analytics/cube",
                    method : "post",
                    data : {
                        signal : this.props.signal_type,
                        start_date : this.props.filter.start_date,
                        end_date : this.props.filter.end_date,
                        resolution : this.props.filter.resolution,
                        entity_list : entity_list,
                        mode : 0,
                        signal_params : this.state.signal_params
                    }
                }).then (res => {
                    let intervals = generateData(this.props.filter.start_date, this.props.filter.end_date, this.props.filter.resolution, res.data.data)
                    console.log("Generated Chart Data :", intervals)
                    let agg_data = aggregateData(intervals, this.props.chart_config)
                    console.log("Aggregated Chart Data :", agg_data)
                    this.setState({...this.state, loading : false, data : agg_data, data_error : null}, () => this.getZeroDataEntities())
                }).catch(err => {
                    this.setState({
                        ...this.state,
                        loading : false,
                        data : null,
                        data_error : err
                    })
                })
            })
        }
    }

    getZeroDataEntities = () => {
        let zero_data = []
        this.props.chart_config.charts.map((chart, i) => {
            let total_value = 0
            this.state.data.map(record => {
                total_value = total_value + record["param" + i]
            })

            if (total_value === 0) {
                zero_data.push(chart.name)
            }
        })

        this.setState({...this.state, zero_data : [...zero_data]})
    }

    handleEntityChange = (value) => {
        this.setState({
            ...this.state,
            entity_list : value
        })
    }

    handle_param_change = (key, value, type) => {
        console.log("Handling Chart Param Change " + key + ", Value " + value)
        if (type === 'multiple') {
            let new_value = value.map(val => {
                return val.value
            })
            this.setState({
                ...this.state,
                signal_params : {
                    ...this.state.signal_params,
                    [key] : new_value
                }
            }, () => console.log("Chart Updated State: ", this.state))
        } else {
            this.setState({
                ...this.state,
                signal_params : {
                    ...this.state.signal_params,
                    [key] : value
                }
            }, () => console.log("Chart Updated State: ", this.state))
        }
    }

    renderSettingsContainer = () => {
        return (
            <Collapse in = {this.state.open_setting}>
                <div style = {{width : '100%', height : this.state.content_height + 'px', padding : '10px', overflow : 'auto'}}>
                    <div style = {{width : '100%', marginTop : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography variant = 'overline'>Entities</Typography>
                    </div>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap', padding : '10px'}}>
                        {this.renderEntities()}
                    </div>
                    <div style = {{width : '100%', marginTop : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                        <Typography variant = 'overline'>Parameters</Typography>
                    </div>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap', padding : '10px'}}>
                        {this.renderFilters()}
                    </div>
                </div>
            </Collapse>
        )
    }

    renderEntities = () =>{
        return (
            <Autocomplete
                style = {{width : '100%'}}
                color = 'primary'
                id="style"
                multiple
                options={this.props.entities}
                value = {this.state.entity_list}
                onChange={(event, newValue) => {
                    if (newValue.length <= 5) {
                        this.handleEntityChange(newValue)
                    }
                }}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => <TextField 
                    {...params} 
                    label= {this.props.chart_config.entity_name} 
                    size = 'small' 
                    variant="outlined" 
                    helperText = "Filter will not be applied if no value is selected. Maximum of 5 Scripts can be applied"
                    fullWidth
                />}
            />
        )
    }

    renderFilters = () => {
        let signal_config = signals.find(signal => signal.type === this.props.signal_type)
        console.log("Signal Config : ", signal_config)
        let filters = []
        filters = signal_config.parameters.map(param => {
            if (param.use) {
                return (
                    <Autocomplete
                        style = {{width : '100%'}}
                        color = 'primary'
                        id="style"
                        multiple = {param.value === 'multiple' ? true : false}
                        options={param.values}
                        value = {this.getValueObject(param.name, this.state.signal_params[param.name])}
                        onChange={(event, newValue) => {
                            console.log("Chart Param Name :", param.name)
                            console.log("Chart Param New Value :", newValue)
                            if (param.value === 'multiple') {
                                if (newValue.length <= 5) {
                                    this.handle_param_change(param.name, newValue, param.value)
                                }
                            } else {
                                this.handle_param_change(param.name, newValue.value, param.value)
                            }
                        }}
                        getOptionLabel={(option) => option.annotation}
                        renderInput={(params) => <TextField 
                                {...params} 
                                label= {param.name.toUpperCase()} 
                                size = 'small' 
                                variant="outlined" 
                                helperText = "Filter will not be applied if no value is selected. Maximum of 5 filters can be applied"
                                fullWidth
                            />}
                    />
                )
            }
        })

        return filters
    }

    renderChartContainer = () => {
        return (
            <Collapse in = {!this.state.open_setting}>
                <div style = {{width : '100%', height : this.state.content_height + 'px', maxHeight : this.state.content_height + 'px', overflow : 'hidden', padding : '10px'}}>
                    {this.state.loading ? this.renderLoader() : this.renderChart()}
                </div>
            </Collapse>
        )
    }

    renderLoader = () => {
        return (
            <div style = {{width : '100%', height : this.state.content_height + 'px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                <CircularProgress color = 'primary'/>
            </div>
        )
    }

    renderChart = () => {
        if (this.props.filter === null) {
            return (
                <div style = {{width : '100%', height : this.state.content_height + 'px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <Typography variant = 'caption' color = 'textSecondary'>Select a Time Interval</Typography>
                </div>
            )
        } else {
            if (this.state.data_error !== null) {
                return (
                    <div style = {{width : '100%', height : this.state.content_height + 'px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <ErrorMessage error_message = "Error Retreiving Data" err = {this.state.data_error}/>
                    </div>
                )
            } else {
                console.log(this.props.chart_config.name, this.state.data)
                return (
                    <Fragment>
                        {this.state.data !== null && this.state.zero_data.length > 0 && <Typography style = {{marginRight : '15px', display : 'block'}} variant = 'caption' align = 'right' color = 'textSecondary'><em>{"No Data found for: "}</em>{this.state.zero_data.join(', ')}</Typography>}
                        <ResponsiveContainer>
                            <ComposedChart data={this.state.data} margin={{top: 20, right: 20, bottom: 20, left: 20}}>
                                <defs>
                                    {this.renderDefs()}
                                </defs>
                                <CartesianGrid stroke='#f5f5f5'/>
                                <XAxis style = {{color: '#000000', fontWeight: 'normal', fontSize: '0.6rem', wordWrap: 'break-word'}} dataKey= "x_axis" interval = "preserveStart" tick={<CustomizedAxisTick/>}/>
                                <YAxis />
                                <Tooltip filterNull />
                                <Legend />
                                {this.renderChartContent()}
                            </ComposedChart>
                        </ResponsiveContainer>
                    </Fragment>
                )
            }
        }
    }

    renderDefs = () => {
        let defs = colors.map((color, i) => {
            return(
                <linearGradient id={"color" + i} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor = {color} stopOpacity={0.8}/>
                    <stop offset="95%" stopColor = {color} stopOpacity={0}/>
                </linearGradient>
            )
        })
        return defs
    }

    renderChartContent = () => {
        if (this.state.loading === false) {
            let charts = this.props.chart_config.charts.map((chart, i) => {
                if (this.state.data !== null) {
                    let total_value = 0
                    this.state.data.map(record => {
                        total_value = total_value + record["param" + i]
                    })
        
                    if (total_value !== 0) {
                        if (chart.type === 'bar') {
                            return (
                                <Bar name = {chart.name} dataKey = {"param" + i} fill = {colors[chart.color]}/>
                            )
                        }
            
                        if (chart.type === 'line') {
                            return (
                                <Line type = "monotone" name = {chart.name} dataKey = {"param" + i} stroke= {colors[chart.color]} />
                            )
                        }
            
                        if (chart.type === 'area') {
                            return (
                                <Area type='monotone' name = {chart.name} dataKey = {"param" + i} fill = {"url(#color" + chart.color + ")"} stroke= {colors[chart.color]}/>
                            )
                        }
                    }
                }
            })
    
            return charts
        }
    }

    renderContent = () => {
        return (
            <div style = {{width : '100%', height : this.state.content_height + 'px'}}>
                {this.renderSettingsContainer()}
                {this.renderChartContainer()}
            </div>
        )
    }

    render() {
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper square elevation = {3} style = {{width : '100%', height: this.props.height + 'px'}}>
                    <div ref = {this.title_bar} style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', borderBottom : '1px solid rgba(0,0,0,0.12)', padding : '10px'}}>
                        <div style = {{flexGrow : 1}} >
                            <Typography variant = 'subtitle2'>{this.props.chart_config.name}</Typography>
                        </div>
                        <div>
                            <MuiTooltip title = "Filters">
                                <IconButton size = 'small' onClick = {this.toggleSettings} color = {this.state.open_setting ? 'primary' : ''}>
                                    <FilterList fontSize = 'small'/>
                                </IconButton>
                            </MuiTooltip>
                        </div>
                        <div>
                            <MuiTooltip title = "Refresh">
                                <IconButton size = 'small' color = {this.state.loading ? 'primary' : ''} onClick = {this.getData}>
                                    <Refresh fontSize = 'small'/>
                                </IconButton>
                            </MuiTooltip>
                        </div>
                    </div>
                    {this.renderContent()}
                </Paper>
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(ChartComponent);